import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import images
import Image1 from '../../../Data/img/mehendi/arabicnew.jpg';
import Image2 from '../../../Data/img/mehendi/all.png';
import Image3 from '../../../Data/img/mehendi/bridal1.jpg';
import Image4 from '../../../Data/img/mehendi/carwa1.png';
import Image5 from '../../../Data/img/mehendi/karwachauth3.jpg';
import Image6 from '../../../Data/img/mehendi/heavynew2.jpg';

const images = [
  { src: Image1, text: 'Arabic Mehendi Design' },
  { src: Image2, text: 'Raksha Bandhan Mehendi Design' },
  { src: Image3, text: 'Bridal Mehendi Design' },
  { src: Image4, text: 'Karwa Chauth Mehendi Design' },
  { src: Image5, text: 'Heavy Karwa Chauth Design' },
  { src: Image6, text: 'Heavy Bridal Mehendi Design' },
];

const CardSlider = () => {
  return (
    <div className="flex flex-col items-center lg:mt-16 px-4">
      <div className="text-center mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-richblack-800 mb-2 font-roboto">Unique & Traditional</h1>
        <h2 className="text-xl md:text-2xl italic text-richblack-600 font-roboto">Designs That Suit You Perfectly</h2>
      </div>

      {/* Slider with Gradient Background */}
      <div className="relative w-full max-w-screen-xl mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-500 via-pink-00 to-red-500 opacity-50 z-0 rounded-lg"></div>
        <Swiper
          spaceBetween={20}
          centeredSlides={true}
          slidesPerView={4}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          navigation
          loop={true}
          modules={[Navigation, Pagination, Autoplay]}
          className="relative z-10 mySwiper"
          breakpoints={{
            375: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="group">
              <div className="relative bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 group-hover:scale-105">
                <Zoom>
                  <img
                    src={image.src}
                    alt={`Slide ${index}`}
                    className="w-full h-64 object-cover"
                  />
                </Zoom>
               
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-lg text-white p-4 text-center">
                  {image.text}
                </div>
               
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default CardSlider;
